import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

import { SessionExpiryWarningComponent } from './session-expiry-warning.component';

@NgModule({
  declarations: [
    SessionExpiryWarningComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
  ],
  exports: [
    SessionExpiryWarningComponent,
  ],
})
export class SessionExpiryWarningModule { }
